import { Paper, Stack, Typography } from "@mui/material";

interface Props {
  caption: string;
  value: string;
  hint: string;
}

export function CapabilityMetricCard({ caption, value, hint }: Props) {
  return (
    <Paper variant="outlined" sx={{ p: 2, flex: 1 }}>
      <Stack gap={0.5}>
        <Typography variant="overline" color="text.secondary" lineHeight={1.4}>
          {caption}
        </Typography>
        <Typography variant="h4" fontWeight="bold">
          {value}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {hint}
        </Typography>
      </Stack>
    </Paper>
  );
}
